<template>
	<div>
		<h3 v-if="grouped.title.committee_name">{{ grouped.title.committee_name }} - {{ grouped.title.meeting_date | moment($t('date-format')) }}</h3>
		<h4 v-if="grouped.title.committee_name">{{ grouped.title.title }}</h4>
		<h3 v-else>{{ grouped.title.title }}</h3>
		
		<div class="accordion-collapse mb-5" v-if="ordered_motions.length" id="accordionExample">
			<div class="accordion-collapse-item" v-for="(title_group,yndex) in title_grouped_motions" :key="yndex">
				<h2>
					<button class="accordion-collapse-heading collapsed" type="button" data-toggle="collapse" :data-target="'#' + title_group.unique_key" aria-expanded="false" :aria-controls="title_group.unique_key">{{ title_group.title || $t('no_title') }}</button>
				</h2>							
				<div class="collapse multi-collapse" :id="title_group.unique_key">
					<div class="accordion-collapse-body">
						<div v-for="(row,index) in title_group.motions" :key="index" class="motion">
							<p v-if="row.minutes_section_id && row.minutes_doc_id"><a class="btn btn-sm btn-outline-secondary" :href="'http://clkapps.winnipeg.ca/DMIS/ViewDoc.asp?DocId=' + row.minutes_doc_id + '&SectionId=' + row.minutes_section_id" target="_blank">{{ $t('minutes') }}</a></p>
							<p v-else-if="row.minutes_doc_id"><a class="btn btn-sm btn-outline-secondary" :href="'http://clkapps.winnipeg.ca/DMIS/ViewDoc.asp?DocId=' + row.minutes_doc_id" target="_blank">{{ $t('minutes') }}</a></p>
							<p v-else>{{ $t('minutes') }}</p>
							<div class="row">
								<div class="col-md-5">
									<p class="mb-2"><span class="font-weight-bold">{{ $t('vote') }}</span>{{ row.vote_description }}</p>
									<p class="mb-2"><span class="font-weight-bold">{{ $t('motion_number') }}</span>{{ row.motion_number }}</p>
									<p class="mb-2"><span class="font-weight-bold">{{ $t('count') }}</span>{{ row.yeas }} - {{ row.nays }}</p>
									<p class="mb-2"><span class="font-weight-bold">{{ $t('result') }}</span>{{ row.result }}</p>
									<p class="mb-2"><span class="font-weight-bold">{{ $t('rule') }}</span>{{ row.vote_rule }}</p>
								</div>
								<div class="col-md-7">								
									<p class="mb-2"><span class="font-weight-bold">{{ $t('yeah') }}</span>
										<ul class="list-inline">
											<li v-for="(member,i) in row.yeah" :key="i" class="list-inline-item">
												<router-link :to="{name: 'members', params: { member: member }}">{{ member }}</router-link>
											</li>
										</ul>
									</p>
									<p class="mb-2"><span class="font-weight-bold">{{ $t('nay') }}</span>
										<ul class="list-inline">
											<li v-for="(member,i) in row.nay" :key="i" class="list-inline-item">
												<router-link :to="{name: 'members', params: { member: member }}">{{ member }}</router-link>
											</li>
										</ul>
									</p>
									<p class="mb-2"><span class="font-weight-bold">{{ $t('absent') }}</span>
										<ul class="list-inline">
											<li v-for="(member,i) in row.absent" :key="i" class="list-inline-item">
												<router-link :to="{name: 'members', params: { member: member }}">{{ member }}</router-link>
											</li>
										</ul>
									</p>
									<p class="mb-0"><span class="font-weight-bold">{{ $t('conflict-tooltip') }}</span>
										<ul class="list-inline">
											<li v-for="(member,i) in row.conflict" :key="i" class="list-inline-item">
												<router-link :to="{name: 'members', params: { member: member }}">{{ member }}</router-link>
											</li>
										</ul>
									</p>
								</div>
							</div>						
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	const simpleHash = str => {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		const char = str.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash &= hash; // Convert to 32bit integer
	}
	return new Uint32Array([hash])[0].toString(36);
	};

	export default {

		props: ['grouped'],
		
		data() {
			return {
				column: '',
				direction: 'ASC',
			}
		},

		filters: {
			clean_percentage(percentage) {
				return Math.round(percentage) + '%'; 
			}
		},

		mounted() {
			// eslint-disable-next-line
			$('[data-toggle="tooltip"]').tooltip(); 
		},

		computed: {
			title_grouped_motions() {
				//groups all the motions by titles
				let title_grouped_order = [];
				let title_groups = {};
				this.ordered_motions.forEach((row) => {
					if (row.title in title_groups === false) {
						title_groups[row.title] = [row];
						title_grouped_order.push(row.title);
					} else {
						title_groups[row.title].push(row);
					}
				})
				return title_grouped_order.map(key => {
					return {
						title: key,
						unique_key: "grouped-" + simpleHash(key + Math.random()),
						motions: title_groups[key]
					}
				});
			},

			ordered_motions() {
				//break the motions up into two arrays and sort them numerically if they start with a number, otherwise string sort
				const re = /^(\d+)\s*\.?(.*)/;
				let sortable = [];
				let unsortable = [];
				this.grouped.motions.forEach((row) => {
					let matches = re.exec(row.title);
					if (matches === null) {
						row.sort = row.title.toUpperCase();
						unsortable.push(row);
					} else {
						row.sort = parseInt(matches[1],10);
						sortable.push(row);
					}
				});
				function compare(a,b) {
					return (a.sort < b.sort) ? -1 : ((a.sort > b.sort) ? 1 : 0);
				}
				sortable.sort(compare);
				unsortable.sort(compare);
				return sortable.concat(unsortable);
			}
		},

		methods: {
			order(column, direction) {
				this.column = column;
				this.direction = direction;
				this.$emit('order', this.column,this.direction);
			},

			open_member(member) {
				this.$router.push({name: 'members', params: { member: member}});
			}
		}		
	}
</script>

<style scoped>
	.list-inline {
		display: inline;
	}
	.list-inline-item {
		margin-right: .35rem;		
	}
	.list-inline-item:not(:last-child)::after {
		content: ",";		
	}
	.member-link:hover{
		cursor: pointer;
	}
	.motion:not(:last-of-type) {
        border-bottom: 1px solid #dee2e6;
		margin-bottom: 1.5rem;
    }
</style>